<div class="container">
  <div class="carousel spacer-vr-48">
    <div class="justify-center layout-row text-center">
      <h2>Popular stories</h2>
    </div>
    <div class="scroll-area">
      <div class="layout-row space-between">
        @for (item of articles; track item) {
          <div class="spacer-hr-24">
            <gh-snippet-mobile class="flex small" [article]="item" [size]="h3" (click)="navClick(item.title, 'popular stories')"></gh-snippet-mobile>
          </div>
        }
      </div>
    </div>
  </div>
</div>
